import { getMessage } from '@/translations'

export const cleanlinessOptions = [
  { code: 'CLEAN', text: getMessage('EditTurnAround.cleanliness.clean') },
  { code: 'DIRTY', text: getMessage('EditTurnAround.cleanliness.dirty') },
  { code: 'WET', text: getMessage('EditTurnAround.cleanliness.wet') },
]
